module.exports = __webpack_public_path__ + "img/mobile-tv.db8dc983.gif";